import type { LangCode } from '@learnforge/i18n';
import type { MechKey } from './keys';
import { en } from './en';
import { zh } from './zh';
import { hi } from './hi';
import { es } from './es';
import { fr } from './fr';
import { ar } from './ar';
import { bn } from './bn';
import { pt } from './pt';
import { ru } from './ru';
import { ur } from './ur';
import { id } from './id';
import { de } from './de';
import { ja } from './ja';
import { mr } from './mr';
import { te } from './te';
import { tr } from './tr';
import { ta } from './ta';
import { vi } from './vi';
import { ro } from './ro';
import { tl } from './tl';
import { ko } from './ko';
import { fa } from './fa';
import { sw } from './sw';
import { it } from './it';
import { pa } from './pa';
import { gu } from './gu';
import { th } from './th';
import { pl } from './pl';
import { uk } from './uk';
import { nl } from './nl';

// Non-English locales are partial (keys missing fall back to English at runtime).
// The cast satisfies createI18n's type, which marks the whole language as optional
// but treats present entries as full records. The runtime handles missing keys safely.
export const locales: Partial<Record<LangCode, Record<MechKey, string>>> & {
  en: Record<MechKey, string>;
} = {
  en,
  zh: zh as Record<MechKey, string>,
  hi: hi as Record<MechKey, string>,
  es: es as Record<MechKey, string>,
  fr: fr as Record<MechKey, string>,
  ar: ar as Record<MechKey, string>,
  bn: bn as Record<MechKey, string>,
  pt: pt as Record<MechKey, string>,
  ru: ru as Record<MechKey, string>,
  ur: ur as Record<MechKey, string>,
  id: id as Record<MechKey, string>,
  de: de as Record<MechKey, string>,
  ja: ja as Record<MechKey, string>,
  mr: mr as Record<MechKey, string>,
  te: te as Record<MechKey, string>,
  tr: tr as Record<MechKey, string>,
  ta: ta as Record<MechKey, string>,
  vi: vi as Record<MechKey, string>,
  ro: ro as Record<MechKey, string>,
  tl: tl as Record<MechKey, string>,
  ko: ko as Record<MechKey, string>,
  fa: fa as Record<MechKey, string>,
  sw: sw as Record<MechKey, string>,
  it: it as Record<MechKey, string>,
  pa: pa as Record<MechKey, string>,
  gu: gu as Record<MechKey, string>,
  th: th as Record<MechKey, string>,
  pl: pl as Record<MechKey, string>,
  uk: uk as Record<MechKey, string>,
  nl: nl as Record<MechKey, string>,
};

export type { MechKey } from './keys';
